import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
import { Home } from './pages/Home';
import { ServiceDetail } from './pages/ServiceDetail';
import { Popup } from './components/Popup';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <BrowserRouter data-id="element-0" data-mp="2rit14zvovkns">
      <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-[#FF9500] selection:text-black" data-id="element-1" data-mp="2mlua4q7bnttt">
        <Header data-id="element-2" data-mp="31b8jhyaweb97" />
        <main data-id="element-3" data-mp="31ayvgg9eye65">
          <Routes data-id="element-4" data-mp="31bia9o3romfy">
            <Route path="/" element={<Home data-id="element-6" data-mp="2wk08wyxu0jug" />} data-id="element-5" data-mp="31c1iue7j1yhb" />
            <Route path="/services/:slug" element={<ServiceDetail data-id="element-8" data-mp="2wifh3h2wjf0a" />} data-id="element-7" data-mp="2wjgq7g0cxrfd" />
            <Route path="*" element={<Home data-id="element-10" data-mp="28tw4ipctkg2e" />} data-id="element-9" data-mp="28ufpkexrnkkn" />
          </Routes>
        </main>
        <Footer data-id="element-11" data-mp="28sbcb6dz997p" />
        <FloatingActions data-id="element-12" data-mp="23vcjcr61v8b3" />
        <Popup data-id="element-13" data-mp="23vulg4fe8gqx" />
      </div>
    </BrowserRouter>;
}